module.exports = __webpack_public_path__ + "img/denglong.47556d46.png";